import { PERMISSION_GROUP_LIST_SUCCESS } from "../constants";

const initialState = {
  list: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
  case PERMISSION_GROUP_LIST_SUCCESS:
    return {
      ...state,
      list: action.payload
    };
  default:
    return state;
  }
}